import { type FunctionComponent } from 'react';
import { PLACEHOLDER_OPTIONS } from '../../../constants/cloudinary/general';
import { HOME_SPLASH_CTA_OPTIONS } from '../../../constants/home/general';
import type { HomeSplashCallToAction } from '../../../types/home.types';
import { LinkButton } from '../../buttons/link-button/link-button.component';
import { Link } from '../../common-components/link/link.component';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';
import { translateAlignmentToStyles } from '../home-splash/splash-helpers/splash.helpers';

export type CallToActionProps = {
	callToAction: HomeSplashCallToAction;
	foregroundTracking: string;
	buttonPositionClassName: string;
	containerClassName?: string;
};

export const CallToAction: FunctionComponent<CallToActionProps> = ({
	callToAction,
	foregroundTracking,
	buttonPositionClassName,
	containerClassName = ''
}) => {
	const { text, style, desktop } = callToAction;
	const { url, tracking } = callToAction.link;
	const dynamicCTAAlignmentStyle = translateAlignmentToStyles(callToAction.alignment);

	return (
		<div className={`absolute ${containerClassName}`} style={{ ...dynamicCTAAlignmentStyle }}>
			<div className="flex flex-column items-center justify-center overflow-hidden w-100 pa0 pa5-l relative">
				<div className={`absolute z-1 ${buttonPositionClassName}`}>
					<div className="dn flex-l">
						<LinkButton buttonStyle={style} size={'DEFAULT'} url={url} analyticsHook={tracking}>
							{text}
						</LinkButton>
					</div>
					<div className="flex dn-l">
						<LinkButton buttonStyle={style} size={'SMALL'} url={url} analyticsHook={tracking}>
							{text}
						</LinkButton>
					</div>
				</div>
				<Link
					url={url}
					ariaLabel="foreground"
					analyticsHook={foregroundTracking}
					className="flex flex-column items-center overflow-hidden"
					automationHook="landing-page-section">
					<CloudinaryImage
						description={desktop.description}
						publicID={desktop.id}
						className="min-h-100"
						options={HOME_SPLASH_CTA_OPTIONS}
						useDimensions={false}
						placeholderOptions={{
							...HOME_SPLASH_CTA_OPTIONS,
							...PLACEHOLDER_OPTIONS
						}}
						lowQualityPlaceholder={desktop.lowQualityPlaceholder}
						bypassLazyLoad={true}
					/>
				</Link>
			</div>
		</div>
	);
};
